import { render, staticRenderFns } from "./TopicCard.vue?vue&type=template&id=093b35c1&scoped=true&"
import script from "./TopicCard.vue?vue&type=script&lang=js&"
export * from "./TopicCard.vue?vue&type=script&lang=js&"
import style0 from "./TopicCard.vue?vue&type=style&index=0&id=093b35c1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093b35c1",
  null
  
)

export default component.exports